import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/header';

// Use relative URL instead of hardcoded HTTP
const API_BASE = '/api';

const CityPage = () => {
  const { cityName } = useParams();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Character limit for description truncation
  const descriptionLimit = 120;

  useEffect(() => {
    fetch(`${API_BASE}/cities/${cityName}/stores`)
      .then(response => response.json())
      .then(data => {
        setStores(data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error loading stores');
        setLoading(false);
        console.error('Error:', err);
      });
  }, [cityName]);

  // Function to truncate text with ellipsis
  const truncateText = (text, limit) => {
    if (!text) return '';
    if (text.length <= limit) return text;
    const lastSpace = text.substring(0, limit).lastIndexOf(' ');
    const truncateAt = lastSpace > 0 ? lastSpace : limit;
    return text.substring(0, truncateAt) + '...';
  };

  if (loading) {
    return <div className="container text-center py-5">Loading...</div>;
  }
  if (error) {
    return <div className="container text-center py-5 text-danger">{error}</div>;
  }

  return (
    <div>
      <Header />
      <div className="container py-5">
        <h1 className="mb-4">Stores in {cityName}</h1>
        <div className="row">
          {stores.map((store) => (
            <div key={store.id} className="col-md-4 mb-4">
              <div className="card shadow-sm h-100">
                <div className="card-body d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    {/* Store Logo */}
                    <Link to={`/${cityName}/${store.url_name}`} className="me-3" style={{ textDecoration: 'none' }}>
                      {store.profile_image_url ? (
                        <img
                          src={`${store.profile_image_url}`}
                          alt={`${store.name} logo`}
                          className="rounded"
                          style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'cover',
                            border: '1px solid #dee2e6',
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            // Fallback to initials if image fails
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      {/* Fallback if no logo */}
                      <div
                        className={`rounded d-${store.profile_image_url ? 'none' : 'flex'} align-items-center justify-content-center bg-light`}
                        style={{
                          width: '60px',
                          height: '60px',
                          fontSize: '1.5rem',
                          fontWeight: 'bold',
                          color: '#6c757d',
                          border: '1px solid #dee2e6',
                        }}
                      >
                        {store.name.charAt(0).toUpperCase()}
                      </div>
                    </Link>
                    
                    {/* Store Name */}
                    <h5 className="card-title mb-0">
                      <Link to={`/${cityName}/${store.url_name}`} style={{ textDecoration: 'none' }}>
                        {store.name}
                      </Link>
                    </h5>
                  </div>
                  {/* Truncated Description */}
                  <p className="card-text flex-grow-1">{truncateText(store.description, descriptionLimit)}</p>
                  {/* View Store Button */}
                  <Link to={`/${cityName}/${store.url_name}`} className="btn btn-primary mt-auto align-self-start">
                    View Store
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CityPage;